import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface ConfigState {
  sidebar: {
    isExpanded: boolean;
    tourLock?: boolean;
  };
  supportChatWindow: {
    open: boolean;
  };
  shareModal: {
    open: boolean;
  };
}

interface ConfigReduxState {
  config: ConfigState;
}

const initialState: ConfigReduxState = {
  config: {
    sidebar: {
      isExpanded: true,
      tourLock: false,
    },
    supportChatWindow: {
      open: false,
    },
    shareModal: {
      open: false,
    },
  },
};

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    updateSidebarConfiguration: (
      state: any,
      action: PayloadAction<Partial<ConfigState["sidebar"]>>,
    ) => {
      state.config.sidebar = {
        ...state.config.sidebar,
        ...action.payload,
      };
    },
    updateSupportWindowState: (state: any, action: PayloadAction<boolean>) => {
      state.config.supportChatWindow = { open: action.payload };
    },
    openShareModal: (state: any) => {
      state.config.shareModal = { open: true };
    },
    closeShareModal: (state: any) => {
      state.config.shareModal = { open: false };
    },
  },
});

export const { updateSidebarConfiguration, updateSupportWindowState, openShareModal, closeShareModal } =
  configSlice.actions;

export default configSlice.reducer;
